import { Dialog, DialogContent } from "randmarcomps";
import { inject, observer } from "mobx-react";
import React, { useState } from "react";
import withManufacturer from "../../../contexts/WithManufacturer";
import { RootStore } from "../../../stores/rootStore";
import LoadingComponent from "../../util/LoadingComponent";

interface IProps {
  store?: RootStore;
  documentNumber: string;
  children: React.ReactNode;
  action: "open" | "download";
  applicationId: string;
}

const GeneratePDFWrapper: React.FC<IProps> = ({ store, documentNumber, children, action, applicationId }) => {
  const [open, setOpen] = useState(false);

  const handleClick = async () => {
    setOpen(true);
    try {
      const response = await store!.documentsStore.getDocumentAsPDF(applicationId, documentNumber);

      const file = new Blob([response], { type: 'application/pdf' });
      const fileURL = URL.createObjectURL(file);

      if (action === "open") {
        window.open(fileURL, "_blank", "noopener,noreferrer");
      } else {
        const fileLink = document.createElement('a');
        fileLink.href = fileURL;
        fileLink.target = "_blank";
        fileLink.rel = "noopener noreferrer";
        fileLink.download = `${documentNumber}.pdf`;
        fileLink.click();
      }
    } finally {
      setOpen(false);
    }
  };

  return (
    <>
      <div onClick={handleClick}>
        {children}
      </div>
      <Dialog open={open} >
        <DialogContent>
          <LoadingComponent text="Generating PDF document..." variant="plain" />
        </DialogContent>
      </Dialog>
    </>
  );
}

export default withManufacturer(inject('store')(observer(GeneratePDFWrapper)));
